import { ShoppingCart } from 'lucide-react'
import { useCart } from '../contexts/CartContext'
import { useLanguage } from '../contexts/LanguageContext'

interface CartButtonProps {
  onClick: () => void
}

const CartButton = ({ onClick }: CartButtonProps) => {
  const { getTotalItems } = useCart()
  const { language } = useLanguage()
  const itemCount = getTotalItems()

  const translations = {
    tr: {
      cart: 'Sepet'
    },
    en: {
      cart: 'Cart'
    },
    ru: {
      cart: 'Корзина'
    }
  }

  const t = translations[language as 'tr' | 'en' | 'ru']

  return (
    <button
      onClick={onClick}
      className="relative inline-flex items-center justify-center w-10 h-10 bg-white text-gray-900 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors font-medium"
      title={t.cart}
    >
      <ShoppingCart className="w-5 h-5 text-gray-900" />
      {itemCount > 0 && (
        <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">
          {itemCount}
        </span>
      )}
    </button>
  )
}

export default CartButton















